import styled from 'styled-components'

export const Main = styled.main`
  max-width: 1024px;
  margin: 0 auto;
  min-height: calc(100vh - ${({ theme }) => theme.gutter} * 2);
  height: 100%;
  position: relative;
  padding: ${({ theme }) => theme.gutterLarge} 0;
`
